import gql from 'graphql-tag';

import starredObjectFragment from '../fragments/starredObjectFragment';

export const mutationCreateStarredObject = gql`
  mutation createStarredObject (
    $conversationID: DokkioID
    $dokkioTagID: DokkioID
    $integrationID: DokkioID
    $remoteID: String
    $integrationItemKind: IntegrationItemKind
  ) {
    createStarredObject (
      conversationID: $conversationID
      dokkioTagID: $dokkioTagID
      integrationID: $integrationID
      remoteID: $remoteID
      integrationItemKind: $integrationItemKind
    ) {
      ...starredObjectFragment
    }
  }
  ${starredObjectFragment}
`;
export default mutationCreateStarredObject;
